<template>
    <div>
        <template v-if="viewPage == true">
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Fee Voucher Bulk Upload </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/feeVouchers"> Cancel </router-link>
                </div>
                <!-- Voucher payment type Modal -->
                <div class="modal fade" data-backdrop="static" id="voucherPaymentType" tabindex="-1" role="dialog" aria-labelledby="voucherPaymentTypeLabel" aria-hidden="true">
                    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <router-link to="/feeVouchers"> <span aria-hidden="true">&times;</span> </router-link>
                            </button>
                            <router-link to="/feeVouchers"> 
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span> </button>
                            </router-link>
                            <div class="modal-body new-batch-popup">
                                <div class="popup-head line-head mt-4 mb-5">
                                    <h2 class="pb-3"> Select Payment Type </h2>
                                </div>
                                <div class="new-batch-boxes-holder">
                                    <div class="row">
                                      <!--   <div class="col">
                                            <div class="batch-box border border-secondary border-3" :class="{ 'active': tick_active == true}" data-toggle="tooltip" data-placement="left" title="Fixed voucher amount will be paid through 1-Bill Payment">
                                                <div class="spin-tick">
                                                    <div class="add-spin"></div>
                                                    <img src="/../images/svgs/new-batch-tick.svg" class="tick-check" alt="" />
                                                </div>
                                                <span @click="proceedTo1bill">
                                                    <div class="icon-size">
                                                        <img src="/../images/Fix.svg" alt="" />
                                                    </div>
                                                    <p> Fixed <br> Payment </p>
                                                </span>
                                            </div>
                                        </div> -->
                                        <div class="col">
                                            <div class="batch-box border border-secondary border-3" :class="{ 'active': tick_active == true}" data-toggle="tooltip" data-placement="right" title="Partial voucher amount will be paid as IBFT through any banking application.">
                                                <div class="spin-tick">
                                                    <div class="add-spin"></div>
                                                    <img src="/../images/svgs/new-batch-tick.svg" class="tick-check" alt="" />
                                                </div>
                                                <span @click="proceedToIBFT">
                                                    <div class="icon-size">
                                                        <img src="/../images/Partial.svg" alt="" />
                                                    </div>
                                                    <p> Partial Payment </p>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="previewMapField == false">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
                            </label>
                            <p> You can also download a sample template <a :href="`${$global.aws_base_url}/csv/BulkVoucherUpload.csv`">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must have the following in order to upload Vouchers in bulk: <br/>
                            1. No repetitions of column names.<br/>
                            2. Only add correct student / Member IDs.<br/>
                            3. Add Number of Invoices needed against each Student / Member ID <br/>
                            4. No special characters in the sheet.<br/>
                            5. There should be no empty cells in a valid row.<br/>
                            6. Student / Member ID, No. of invoices, Due date of first invoice and Due date interval are required to upload a batch.</p>">
                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" :src="$global.aws_base_url+'/images/svgs/upload-icon.svg'" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Payroll Plus to process your sheet."></i> </label>
                                <div class="mandatory-tags">
                                    <div class="mandatory-fields-inner" style="flex-wrap: wrap;">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Student ID"> <i :class="[mand_studentid ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Student ID </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Campus"> <i :class="[mand_campus ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Campus </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="No. of invoices"> <i :class="[mand_noofinvoices ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> No. of invoices </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Admission Fee"> <i :class="[mand_admissionFee ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Admission Fee </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Registration Fee"> <i :class="[mand_registrationFee ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Registration Fee </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Tuition Fee"> <i :class="[mand_tuitionFee ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Tuition Fee </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Security Charges"> <i :class="[mand_securityCharges ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Security Charges </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Head Office Fund"> <i :class="[mand_headOfficeFund ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Head Office Fund </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Annual Fund"> <i :class="[mand_annualFund ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Annual Fund </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Examination Charges"> <i :class="[mand_examinationCharges ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Examination Charges </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Transportation Charges"> <i :class="[mand_transportationCharges ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Transportation Charges </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Rent"> <i :class="[mand_rent ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Rent </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Fine"> <i :class="[mand_fine ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Fine </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Others"> <i :class="[mand_others ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Others </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Due Date First Invoice"> <i :class="[mand_duedatefirstinvoice ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Due Date First Invoice </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Due Date Interval"> <i :class="[mand_duedateinterval ? 'fas fa-check' : 'fas fa-ban text-danger']"></i> Due Date Interval </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="viewPage == null">
            <preLoader></preLoader>
        </template>
        <template v-if="viewPage == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage : true,
                previewMapField : false,
                fileAdded : false,
                dropZoneObject : null,
                mand_studentid : false,
                mand_campus : false,
                mand_noofinvoices : false,
                mand_admissionFee : false,
                mand_registrationFee : false,
                mand_tuitionFee : false,
                mand_securityCharges : false,
                mand_headOfficeFund : false,
                mand_annualFund : false,
                mand_examinationCharges : false,
                mand_transportationCharges : false,
                mand_rent : false,
                mand_fine : false,
                mand_others : false,
                mand_duedatefirstinvoice : false,
                mand_duedateinterval : false,
                proceedButtonflag : false,
				tick_active : false,
                voucher_payment_type : 'ibft',
                companyCampusesArray : []
            }
        },
        methods: {
            proceedToIBFT(){
                this.tick_active = true;
                setTimeout(() => {
                    $('#voucherPaymentType').modal('hide');
                }, 1000);
                this.voucher_payment_type = 'ibft';
			},
            proceedTo1bill(){
                this.tick_active = true;
                setTimeout(() => {
                    $('#voucherPaymentType').modal('hide');
                }, 1000);
                this.voucher_payment_type = '1Bill';
			},
            processDropzoneQueue(){

            },
            getCampusData(){
                var that = this;
                axios.get('/api/getFeeBulkUploadStudentsData')
                .then(response => {
                    if(response.status == 200){
                        response.data.campuses.forEach(campus => {
                            that.companyCampusesArray.push({id:campus.id,name:campus.name});
                        });
                    }else{
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            handleGeneratePayrollButton(){
                if(this.fileAdded == true){
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    timeout: 180000,
                    url: that.$global.base_url+'api/feeVouchersBulkUploadFile',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                            this.on("addedfile", function(file) {
                                that.fileAdded = true;
                                that.checkFileForErrors(file);
                                that.handleGeneratePayrollButton();
                            });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            $('div.progress').addClass('step-three').removeClass('step-two');
                            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            // Will send the filesize along with the file as POST data.
                            formData.append("filesize", file.size);
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            var campusNames = [];
                            var campusids = [];
                            that.companyCampusesArray.forEach(campus => {
                                campusNames.push(campus.name);
                                campusids.push(campus.id);
                            });
                            // Will send the filesize along with the file as POST data.
                            formData.append("campusNames", JSON.stringify(campusNames));
                            formData.append("campusids", JSON.stringify(campusids));
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                            formData.append("voucher_payment_type",that.voucher_payment_type);
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                            }
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            if(obj.code == "200") {
                                that.showToastBox('success','File has been uploaded');
                                that.$router.push('/feeVouchers');
                            }else{
                                that.showAlertBox('error','Error in file',obj.msg);
                            }
                        });
                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                fileAdded = false;
                                that.showAlertBox('error','Error in file');
                                this.removeFile(file);
                            }
                            var msg = 'Error:'+xhr.status+' '+xhr.statusText;
                            that.showAlertBox('error','Error in file', msg);
                            file.status = Dropzone.QUEUED;
                        });
                    }
                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList
                        if(rowName.trim().toLocaleLowerCase() == 'student id'){
                            that.mand_studentid = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'campus'){
                            that.mand_campus = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'no of invoices'){
                            that.mand_noofinvoices = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'admission fee'){
                            that.mand_admissionFee = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'registration fee'){
                            that.mand_registrationFee = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'tuition fee'){
                            that.mand_tuitionFee = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'security charges'){
                            that.mand_securityCharges = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'head office fund'){
                            that.mand_headOfficeFund = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'annual fund'){
                            that.mand_annualFund = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'examination charges'){
                            that.mand_examinationCharges = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'transportation charges'){
                            that.mand_transportationCharges = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'rent'){
                            that.mand_rent = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'fine'){
                            that.mand_fine = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'others'){
                            that.mand_others = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'due date first invoice'){
                            that.mand_duedatefirstinvoice = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'due date interval'){
                            that.mand_duedateinterval = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'student id') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'student id') ? true : fieldMap;
                        comboBox += '<option value="Student Id" '+selected+'>Student Id</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'campus') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'campus') ? true : fieldMap;
                        comboBox += '<option value="campus" '+selected+'>Campus</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'no of invoices') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'no of invoices') ? true : fieldMap;
                        comboBox += '<option value="No of invoices" '+selected+'>No of invoices</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'admission fee') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'admission fee') ? true : fieldMap;
                        comboBox += '<option value="Admission Fee" '+selected+'>Admission Fee</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'registration fee') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'registration fee') ? true : fieldMap;
                        comboBox += '<option value="Registration Fee" '+selected+'>Registration Fee</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'tuition fee') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'tuition fee') ? true : fieldMap;
                        comboBox += '<option value="Tuition Fee" '+selected+'>Tuition Fee</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'security charges') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'security charges') ? true : fieldMap;
                        comboBox += '<option value="Security Charges" '+selected+'>Security Charges</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'head office fund') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'head office fund') ? true : fieldMap;
                        comboBox += '<option value="Head Office Fund" '+selected+'>Head Office Fund</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'annual fund') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'annual fund') ? true : fieldMap;
                        comboBox += '<option value="Annual Fund" '+selected+'>Annual Fund</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'examination charges') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'examination charges') ? true : fieldMap;
                        comboBox += '<option value="Examination Charges" '+selected+'>Examination Charges</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'transportation charges') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'transportation charges') ? true : fieldMap;
                        comboBox += '<option value="Transportation Charges" '+selected+'>Transportation Charges</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'rent') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'rent') ? true : fieldMap;
                        comboBox += '<option value="Rent" '+selected+'>Rent</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'fine') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'fine') ? true : fieldMap;
                        comboBox += '<option value="Fine" '+selected+'>Fine</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'others') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'others') ? true : fieldMap;
                        comboBox += '<option value="Others" '+selected+'>Others</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'due date first invoice') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'due date first invoice') ? true : fieldMap;
                        comboBox += '<option value="Due date first invoice" '+selected+'>Due date first invoice</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'due date interval') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'due date interval') ? true : fieldMap;
                        comboBox += '<option value="Due date interval" '+selected+'>Due date interval</option>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },
            generateButtonProccess(){
                 if(this.mand_studentid == true && this.mand_campus == true && this.mand_noofinvoices == true && this.mand_admissionFee == true && this.mand_registrationFee == true && this.mand_tuitionFee == true && this.mand_securityCharges == true && this.mand_headOfficeFund == true && this.mand_annualFund == true  && this.mand_examinationCharges == true && this.mand_transportationCharges == true && this.mand_rent == true && this.mand_fine == true && this.mand_others == true && this.mand_duedatefirstinvoice == true && this.mand_duedateinterval == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },
            checkForMandField(){
                $( "select.selectpicker" ).each(function() {
                    this.mand_studentid = this.mand_campus = this.mand_noofinvoices = this.mand_admissionFee = this.mand_registrationFee = this.mand_tuitionFee = this.mand_securityCharges = this.mand_headOfficeFund= this.mand_annualFund = this.mand_examinationCharges = this.mand_transportationCharges = this.mand_rent = this.mand_fine = this.mand_others = this.mand_duedatefirstinvoice = this.mand_duedateinterval = false;
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'student id') this.mand_studentid = true;
                    if(selVal.trim().toLowerCase() == 'campus') this.mand_campus = true;
                    if(selVal.trim().toLowerCase() == 'no of invoices') this.mand_noofinvoices = true;
                    if(selVal.trim().toLowerCase() == 'admission fee') this.mand_admissionFee = true;
                    if(selVal.trim().toLowerCase() == 'registration fee') this.mand_registrationFee = true;
                    if(selVal.trim().toLowerCase() == 'tuition fee') this.mand_tuitionFee = true;
                    if(selVal.trim().toLowerCase() == 'security charges') this.mand_securityCharges = true;
                    if(selVal.trim().toLowerCase() == 'head office fund') this.mand_headOfficeFund = true;
                    if(selVal.trim().toLowerCase() == 'annual fund') this.mand_annualFund = true;
                    if(selVal.trim().toLowerCase() == 'examination charges') this.mand_examinationCharges = true;
                    if(selVal.trim().toLowerCase() == 'transportation charges') this.mand_transportationCharges = true;
                    if(selVal.trim().toLowerCase() == 'rent') this.mand_rent = true;
                    if(selVal.trim().toLowerCase() == 'fine') this.mand_fine = true;
                    if(selVal.trim().toLowerCase() == 'others') this.mand_others = true;
                    if(selVal.trim().toLowerCase() == 'due date first invoice') this.mand_duedatefirstinvoice = true;
                    if(selVal.trim().toLowerCase() == 'due date interval') this.mand_duedateinterval = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    //hide the department, branch and city field sets if deselect
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'student id') that.mand_studentid = true;
                    if(selVal.trim().toLowerCase() == 'campus') that.mand_campus = true;
                    if(selVal.trim().toLowerCase() == 'no of invoices') that.mand_noofinvoices = true;
                    if(selVal.trim().toLowerCase() == 'admission fee') this.mand_admissionFee = true;
                    if(selVal.trim().toLowerCase() == 'registration fee') this.mand_registrationFee = true;
                    if(selVal.trim().toLowerCase() == 'tuition fee') this.mand_tuitionFee = true;
                    if(selVal.trim().toLowerCase() == 'security charges') this.mand_securityCharges = true;
                    if(selVal.trim().toLowerCase() == 'head office fund') this.mand_headOfficeFund = true;
                    if(selVal.trim().toLowerCase() == 'annual fund') this.mand_annualFund = true;
                    if(selVal.trim().toLowerCase() == 'examination charges') this.mand_examinationCharges = true;
                    if(selVal.trim().toLowerCase() == 'transportation charges') this.mand_transportationCharges = true;
                    if(selVal.trim().toLowerCase() == 'rent') this.mand_rent = true;
                    if(selVal.trim().toLowerCase() == 'fine') this.mand_fine = true;
                    if(selVal.trim().toLowerCase() == 'others') this.mand_others = true;
                    if(selVal.trim().toLowerCase() == 'due date first invoice') that.mand_duedatefirstinvoice = true;
                    if(selVal.trim().toLowerCase() == 'due date interval') that.mand_duedateinterval = true;

                    that.generateButtonProccess();
                });
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var column = false;
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        that.showAlertBox('error','Missing column');
                    }
                    if(column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },
        },
        created() {
        },
        mounted(){
            var that = this;
            if(this.$route.params.feeType == 'VOUCHER') {
                $('#voucherPaymentType').modal('show');
            }
            this.getCampusData();
            this.initDropZone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            $("#drop").dropzone();
            $(window.document).on('show.bs.modal', '.modal', function (event) {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function() {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });
        }
    }
</script>
<style scoped>
    .icon-size {
        min-height: 73px;
    }
</style>
